import Swiper from "../../../../../vendor/swiper/swiper-bundle.esm.browser";

export default class CtaListSwiper {
    constructor($el) {
        this.$el = $el;
        this.slide = this.slide.bind(this);
        this.slide();
    }

    slide() {
        var swiper = new Swiper(this.$el, {
            loop: true,
            draggable: true,
            navigation: {
                nextEl: this.$el.querySelector('[data-cta-swiper-next]'),
                prevEl: this.$el.querySelector('[data-cta-swiper-prev]'),
            },
        });
    }
}